// extracted by mini-css-extract-plugin
export default {"text":"ShareModal_text__JfibN","share":"ShareModal_share__ieXRD","notice":"ShareModal_notice__O-ew2","container":"ShareModal_container__Xdlkm","link":"ShareModal_link__4X98-"};